<script setup lang="ts">
interface SpacerBlok {
    _uid: string;
    size: string;
}

defineProps<{ blok: SpacerBlok }>();
</script>

<template>
    <div
        v-editable="blok"
        :class="{
            'h-8 xl:h-12': blok.size === 'small',
            'h-12 xl:h-20': !blok.size || blok.size === 'medium',
            'h-20 xl:h-32': blok.size === 'large',
        }"
    />
</template>
